import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';

export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  ObjectId: any
}

@Component({
    selector: 'app-user-multi-column-dropdown',
    templateUrl: './user-multi-column-dropdown.component.html',
    styleUrls: ['./user-multi-column-dropdown.component.scss'],
    standalone: false
})
export class UserMultiColumnDropdownComponent implements OnInit {

  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;

  getdata: any = [];
  reportData: any;
  userid: any;
  fieldslist: any = {};

  backgroundColorButton = "";

  constructor(private commonService: CommonService, private snackbar: MatSnackBar, private constants: constants, public dialogref: MatDialogRef<UserMultiColumnDropdownComponent>,
    @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData, private dropdownService: ReportingServiceService, private loginService: LoginService, private localStorageSettings: LocalStorageSettingsService,private linkservice: ReportlinksserviceService) {
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: ActionCheckBox,
    }

    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
  }

  ngOnInit() {

    console.log(this.constants.userid)

    this.columnDefs = [
      {
        headerName: 'Select',
        headerTooltip: 'Select',
        tooltipValueGetter: (params) => 'Select/Unselect',
        field: 'chckBox',
        filter: false,
        cellRenderer: (params) => {
          // Create a checkbox element
          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.checked = params.value;
          
          // Set larger size using inline styles
          checkbox.style.width = '18px';
          checkbox.style.height = '18px';
          
          // Attach the click event to call onSelectionChanged
          checkbox.addEventListener('click', (event) => {
            this.onSelectionChanged(params);
          });
      
          return checkbox;
        },
        width: 120
      }
      
      ,
      {
        headerName: 'Dataset Name',
        headerTooltip: 'Dataset Name',
        tooltipValueGetter: (params) => 'Dataset Name: ' + params.value,
        field: 'datasetname',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Type',
        headerTooltip: 'Type',
        tooltipValueGetter: (params) => 'Access Type : ' + params.value,
        field: 'type',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Object Name',
        headerTooltip: 'Object Name',
        tooltipValueGetter: (params) => 'Object Name : ' + params.value,
        field: 'datasetObjectname',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Description',
        headerTooltip: 'Description',
        tooltipValueGetter: (params) => 'Description : ' + params.value,
        field: 'description',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Object Group',
        headerTooltip: 'Object Group',
        tooltipValueGetter: (params) => 'Object Group : ' + params.value,
        field: 'objectGroup',
        filter: 'agTextColumnFilter',
        width: 200
      },
    ]
    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

  }

  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    let res: any
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    console.log(this.constants.ReportCreation)
    console.log(this.constants.UserColoumns)
    console.log(this.constants.userid)
    // this.getdata = await this.commonService.retrieveRecordService(this.constants.ReportCreation);
    this.linkservice.retrievereport(this.localStorageSettings.getSettings("UserId"), this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(response =>{
      console.log(response);
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        this.getdata=response;
        console.log()
        this.gridAPI.setGridOption('rowData', this.getdata);
        if (this.getdata.objectid == "") {
          this.gridAPI.setGridOption('rowData', this.getdata);
          this.gridAPI.hideOverlay();
        }
        else {
          console.log(this.getdata);
          this.gridAPI.setGridOption('rowData', this.getdata);
          // this.gridAPI.forEachNode(node => {
          //   console.log("node data" + JSON.stringify(node.data))
          //   if (this.data.ObjectId == node.data.objectid) {
          //     node.setSelected(true);
          //   }
          // })
        }
      }
    })
    // for (let i = 0; i < this.getdata.length; i++) {
    //   this.fieldslist = JSON.parse(this.getdata[i].fieldslist);
    //   //console.log(this.fieldslist["fieldListKeyName"]);
    //   this.getdata[i].fieldslist = this.fieldslist;
    // }
   
  }

  selectAll(e) {
    console.log(e)
    let d = {
      "userid": e.rowData.userid,
      "objectid": e.rowData.objectid,
      "datasetname": e.rowData.datasetname,
      "accesstype": e.rowData.accesstype,
      "fieldslist": e.rowData.fieldslist,
    }
    this.reportData = d
    console.log(this.reportData)
  }

  closePopup() {
    this.dialogref.close(null)
  }

  senddata(data: any) {
    this.dialogref.close(data);
  }

  onSelectionChanged(params) {
    console.log('Checkbox clicked for row:', params.data);
    this.senddata(params.data);
  }

}



